module.exports = {"id":"dp4_1l1q4","text":"Protecting Devices","instructions":"What is the purpose of multi-factor authentication?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.1","questionType":"PickOne","random":true,"options":[{"id":"dp4_1l1q4-a1","text":"Add an extra security step","score":1.8},{"id":"dp4_1l1q4-a2","text":"Make logins faster only","score":0},{"id":"dp4_1l1q4-a3","text":"Replace all passwords","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.1/l1q4.json
// module id = 1205
// module chunks = 41